/**
 * Move Hub analytics (move-hub observability / AC — NFR).
 *
 * Pushes GA4 events into the GTM dataLayer. It only runs on a Move Hub page (a
 * `[data-mh-analytics]` root), fires a `move_hub_view` on load with the service
 * type + current stage as shared context, then tracks interactions two ways:
 *
 *  - Delegated clicks on any `[data-mh-event]` element (with optional
 *    `data-mh-param-*` params, e.g. `data-mh-param-stage`).
 *  - The hub's own window events (welcome video / help / move-details modals).
 *
 * No PII is sent — only structural context (service type, stage key, FAQ
 * question text, checklist item key). GTM forwards these to GA4.
 */
function push(event, params = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
}

function collectParams(el) {
    const params = {};

    for (const [key, value] of Object.entries(el.dataset)) {
        if (key.startsWith('mhParam') && value != null && value !== '') {
            // data-mh-param-stage -> mhParamStage -> stage
            const name = key.slice('mhParam'.length);
            params[name.charAt(0).toLowerCase() + name.slice(1)] = value;
        }
    }

    return params;
}

function init() {
    const root = document.querySelector('[data-mh-analytics]');

    if (!root) {
        return;
    }

    const context = {
        service_type: root.dataset.mhService || null,
        move_stage: root.dataset.mhStage || null,
    };

    push('move_hub_view', context);

    document.addEventListener('click', (event) => {
        const el = event.target.closest('[data-mh-event]');

        if (!el) {
            return;
        }

        push(el.dataset.mhEvent, { ...context, ...collectParams(el) });
    });

    const windowEvents = {
        'open-welcome-video': 'move_hub_video_open',
        'open-help-faq': 'move_hub_help_open',
        'open-move-details': 'move_hub_details_open',
    };

    for (const [name, eventName] of Object.entries(windowEvents)) {
        window.addEventListener(name, () => push(eventName, context));
    }
}

if (document.readyState !== 'loading') {
    init();
} else {
    document.addEventListener('DOMContentLoaded', init);
}
